import React from 'react';
import './scheduleComponent.css';

const ScheduleComponent = () => {
  const schedule = [
    { time: '6:00 PM: ', event: ' Doors Open' },
    { time: '6:30 PM: ', event: ' Steak dinner by Weekends begins serving' },
    { time: '7:30 PM: ', event: ' Opening act with Renegade' },
    { time: '8:30 PM: ', event: ' Headliner Chris Cagle takes the stage' },
  ];

  return (
    <div className="schedule-container">
      <h2>“The Venue” at Sunset Pointe, 2510 I-27, Plainview, Texas</h2>
      <ul className="schedule-list">
        {schedule.map((entry, index) => (
          <li key={index} className="schedule-item">
            <span className="schedule-time">{entry.time}</span>
            <span className="schedule-event">{entry.event}</span>
          </li>
        ))}
      </ul>
      <div className='schedule-text'>
        Boot scooting available all night! Cash beer and wine bar to be featured, as well as a raffle for various items.
      </div>
    </div>
  );
};

export default ScheduleComponent;
